<template>
  <Homepage />
</template>

<script>
  import Homepage from '../components/Home'

  export default {
    name: 'Home',

    components: {
      Homepage,
    },
  }
</script>
